<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M6.667 7.79c0 .69.194 1.337.535 1.894H5.667c-.92 0-1.667.707-1.667 1.58V26.42c0 .873.746 1.58 1.667 1.58h20.666c.92 0 1.667-.707 1.667-1.579V11.263c0-.872-.746-1.579-1.667-1.579h-1.535c.34-.557.535-1.204.535-1.895 0-2.092-1.79-3.789-4-3.789-1.487 0-2.785.769-3.474 1.91L16 8.641l-1.859-2.73C13.451 4.768 12.154 4 10.667 4c-2.21 0-4 1.697-4 3.79zm5.764-.895l-.026-.044a2.02 2.02 0 00-1.738-.956c-1.105 0-2 .848-2 1.894 0 1.047.895 1.895 2 1.895h3.663l-1.899-2.79zm5.239 2.79h3.663c1.105 0 2-.85 2-1.896 0-1.046-.895-1.894-2-1.894-.74 0-1.39.38-1.738.956l-.026.044-1.9 2.79zM14 11.578H6v14.526h8V11.58zm4 0v14.526h8V11.58h-8z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'objectsGiftOutline'
}
</script>
